import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const hadController = Boolean(navigator.serviceWorker.controller);
    let hasReloadedForUpdate = false;

    const reloadForUpdate = () => {
      if (!hadController || hasReloadedForUpdate) {
        return;
      }

      hasReloadedForUpdate = true;
      window.location.reload();
    };

    navigator.serviceWorker.addEventListener('controllerchange', reloadForUpdate);
    navigator.serviceWorker.addEventListener('message', event => {
      if (event.data && event.data.type === 'SW_UPDATED') {
        reloadForUpdate();
      }
    });

    navigator.serviceWorker.register('/service-worker.js').then(registration => {
      const refreshRegistration = () => {
        registration.update().catch(() => {});
      };

      refreshRegistration();

      window.addEventListener('online', refreshRegistration);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          refreshRegistration();
        }
      });
    }).catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
